// extracted by mini-css-extract-plugin
module.exports = {"container":"RemarkCounts_container__i8wVC","withDivider":"RemarkCounts_withDivider__3utGF","markerReview":"RemarkCounts_markerReview__1voJH"};